var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hangup_contents"},[_c('span',{staticClass:"btn btn_hangup"},[_c('router-link',{attrs:{"to":{ name: 'Home' }}},[_vm._v("テレビ電話を終了する")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }